import React from 'react';

/**
 * Development-only extension point for username/password test forms.
 *
 * Production auth is SSO-only. For local E2E user seeding we sometimes need
 * Sharetribe's native username/password login/signup surfaced in the UI. That
 * code must never reach a remote branch, so it lives in an untracked, gitignored
 * sibling file `DevAuthTestForms.local.js` that this loader pulls in only when it
 * is present AND only in a development build.
 *
 * In a production build `process.env.NODE_ENV` is inlined to `"production"`, so
 * the whole `if` branch (including the require.context) is statically eliminated
 * — no dev-auth code ships in the bundle. `require.context` is used instead of a
 * bare `require` because it tolerates the target file being absent (it yields an
 * empty context rather than a "module not found" build error), so a fresh clone
 * without the local file still builds and runs.
 */
let Impl = () => null;

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line
  const ctx = require.context('./', false, /DevAuthTestForms\.local\.js$/);
  const key = ctx.keys()[0];
  if (key) {
    Impl = ctx(key).default;
  }
}

const DevAuthTestForms = props => <Impl {...props} />;

export default DevAuthTestForms;
